import React, {useEffect, useMemo, useState} from 'react';
import __ from "lodash";
import {Grid, IconButton, TextField, Tooltip} from '@material-ui/core';
import {ComboSelect, FormDialog, MaskedText} from "../../../controls";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import {HighlightOff, Search} from "@material-ui/icons";
import ContractSelect from "./ContractSelect";

const emptySearch = {
  contractName: "",
  contractType: "",
  companyType: "ANY",
  contractedPartyUuid: null,
  disabled: true
}

const ContractSelectDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const formatChars = props.formatChars;
  const preSelection = props.preSelection;
  const eventBus = SystemData.eventBus;

  const [record, setRecord] = useState({
    ...emptySearch,
  });

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    noteUuid: null,
    title: 'Contract Selector'
  });

  const [disableSearch, setDisableSearch] = useState(true);

  const checkSearchDisabled = (record) => {
    if (record && typeof record === 'object') {
      for (const [key, value] of Object.entries(__.omit(record, ["companyType"]))) {
        if (value && value !== "") {
          return false;
        }
      }
    }
    return true;
  }

  const handleSearch = (record) => {
    if (eventBus) {
      eventBus.trigger("ContractSelect.search", {...record});
    }
  }


  useEffect(()=> {
    const open = async (params) => {
      const {title, message, canEdit} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, message});
    }
    eventBus.bind("ContractSelect.open", open);
    return () => {
      eventBus.unbind("ContractSelect.open", open);
    }
  }, [dialogState]);

  if (dialogState.showDialog) {
    return (
      <FormDialog
        title={dialogState.title || "Contract Selector"}
        open={dialogState.showDialog}
        message={dialogState.message || ""}
        messageAboveScroll={true}
        record={record}
        dialogOptions={{width: "md", maxWidth: "md", fullWidth: true}}
        classes={classes}
        // validator={Validator}
        buttons = {{
          // save:{icon: "check_circle", key: "Update", label: "Select Contract", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
              setDialogState({...dialogState, showDialog: false, record: null});
          } else {
            setDialogState({...dialogState, showDialog: false, record: null});
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3}>

          <Grid item xs={4} checkChildren={true}>
            {(record, changeRecord, changeButtonState)=>
              <MaskedText
                id="contractName"
                label="Contract Description"
                inputLabelProps={{shrink: true}}
                mask={"x".repeat(50)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
                onChange={value => {
                  changeRecord({contractName: value});
                  setDisableSearch(checkSearchDisabled({...record, contractName: value}));
                }}
              />
            }
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord, changeButtonState)=>
              <ComboSelect
                id="contractType"
                group="CONTRACT TYPES"
                subGroup=""
                fullWidth
                label="Contract Type"
                inputLabelProps={{ shrink: true }}
                returnType={"object"}
                onChange={(value, returnObject) => {
                  if (returnObject && !__.isEmpty(returnObject)) {
                    let companyType = "ANY";
                    let contractedPartyUuid = record.contractedPartyUuid;
                    if (__.has(returnObject, "data") && __.has(returnObject.data, "companyType")) {
                      companyType = returnObject.data.companyType;
                    }
                    if (record.companyType !== companyType)
                      contractedPartyUuid = null;
                    changeRecord({contractType: value, companyType: companyType, contractedPartyUuid});
                    setDisableSearch(checkSearchDisabled({...record, contractType: value, companyType: companyType, contractedPartyUuid}));
                  } else {
                    props.onChange(value);
                  }
                }}
              />
            }
          </Grid>
          <Grid item xs={4} checkChildren={true}>
            {(record, changeRecord, changeButtonState)=>
              <CompanyUuidLookup
                id="contractedPartyUuid"
                label="Contracted Company"
                shrink={true}
                // readOnly={record.contractType}
                companyType={record.companyType ? record.companyType  : record.contractType === "CHARTER" ? "CLIENT" : record.contractType === "SGHA" ? "SUPPLIER" : "ANY"}
                value={record.contractedPartyUuid}
                returnType={"object"}
                onChange={(returnObject) => {
                  if (returnObject.found) {
                    const contractedParty = returnObject.data
                    const data = {
                      ...record,
                      contractedPartyUuid: contractedParty.companyUuid,
                    }
                    changeRecord(data);
                    setDisableSearch(checkSearchDisabled({...data}));
                  } else {
                    props.onChange(returnObject.value);
                  }
                }}
              />
            }
          </Grid>
          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord, changeButtonState)=>
              <div>
                <IconButton style={{padding: "20px 5px"}} disabled={disableSearch} onClick={()=>{handleSearch(record)} }>
                  <Tooltip title={"Click to search"}>
                    <Search color={disableSearch ? "#909090" : "primary"}/>
                  </Tooltip>
                </IconButton>
                <IconButton style={{padding: "20px 5px"}} disabled={disableSearch} onClick={()=>{changeRecord({...emptySearch}); setDisableSearch(true); handleSearch({...emptySearch})}}>
                  <Tooltip title={"Click to clear all search fields"}>
                    <HighlightOff style={{}} color={disableSearch ? "#909090" : "primary"}/>
                  </Tooltip>
                </IconButton>
              </div>
            }
          </Grid>
          <Grid item xs={12} checkChildren={true}>
            <div style={{border: "solid 1px #b9b9b9" }}>
              <ContractSelect
                width={700}
                height={400}
                classes={classes}
                systemData={SystemData}
                onSelect={(contractUuid) => {
                  if (props.onChange) {
                    props.onChange(contractUuid);
                  }
                  setDialogState({...dialogState, showDialog: false, record: null});
                }
              }
              />
            </div>
          </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default ContractSelectDialog;
